module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "form__submit button",
    class: _vm.classes,
    attrs: {
      "href": "javascript:void(0);",
      "data-acc": _vm.acc.toLowerCase(),
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.isLoading) ? _c('spinner', {
    attrs: {
      "contained": true
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v("\n      " + _vm._s(_vm.L.localize(_vm.label)) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-acd44b0e!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/forms/Btn.vue
// module id = 755
// module chunks = 1